var map = {
	"./logo-big-picture-medical-mark.svg": 61070,
	"./logo-big-picture-medical-regular.svg": 47679,
	"./logo-jnj-mark.svg": 57829,
	"./logo-jnj-regular.svg": 79176,
	"./logo-menicon-mark.svg": 45377,
	"./logo-menicon-regular.svg": 2618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30357;